import Rollbar from 'rollbar';

import { Injectable, Inject, InjectionToken, ErrorHandler, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAccountId } from '../account/store/account.selectors';

const rollbarConfig = {
  accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.ROLLBAR_ENV,
    code_version: process.env.SOURCE_VERSION,
    guess_uncaught_frames: true,
  },
  ignoredMessages: ['Object Not Found Matching Id:4', 'Failed to fetch', '(unknown): Script error.', 'Script error.'],
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar, private injector: Injector) {}

  private get store() {
    return this.injector.get(Store);
  }

  handleError(err: any): void {
    if (err.url) {
      this.store.pipe(selectAccountId).subscribe((accountId) => {
        const urlPattern = new RegExp(`${accountId}/api/([a-z]+)`).exec(err.url);

        let endpoint = err.url;
        if (urlPattern && urlPattern.length && urlPattern[1]) {
          [, endpoint] = urlPattern;
        }

        const errorMessage = `HTTP Error Code: ${err.status} Endpoint: ${endpoint}`;
        console.error(errorMessage);
        this.rollbar.error(errorMessage);
      });
    } else {
      console.error(err.originalError || err);
      this.rollbar.error(err.originalError || err);
    }
  }
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}
